import Box from '@mui/material/Box';
import { memo } from 'react';
import ColumnText from './ColumnText';
import Chip from '@mui/material/Chip';

const DataCalendarTimes = (props: any) => {
  return props.daysTimes.map((time: any, index: number) => (
    <tr
      key={`${time['hm']}-${index}`}
      style={{cursor: 'pointer', height: '30px', fontSize: '12px'}}
      className='calendar-tr'
    >
      {time &&
        time['columns'] &&
        time['columns'].map((column: any, index: number) =>
          index === 0 ? (
            <td
              key={`${time['hm']}-${index}`}
              align='left'
              className={`calendar-td ${time['show'] ? '' : 'border-top-none'}`}
            >
              {column['text'][0]['label']}
            </td>
          ) : column['id'] && column['id'] > 0 ? (
            <td
              key={time['hm'] + column['index']}
              align='left'
              className={`calendar-td ${time['show'] ? '' : 'border-top-none'}`}
              style={{
                height: `${
                  (column['rowspan'] === 0 ? 6 : column['rowspan']) * 30
                }px`,
                padding: '6px'
              }}
              rowSpan={column['rowspan'] ? column['rowspan'] : 6}
              onClick={() =>
                props.handleOpenDialogDetail(
                  column['id'],
                  column['patientid'],
                  column['index']
                )
              }
            >
              <Box
                sx={{
                  p: '6px',
                  minHeight: `${
                    (column['rowspan'] === 0 ? 6 : column['rowspan']) * 30
                  }px`,
                  height: '100%',
                  backgroundColor: column['color']['bg'],
                  borderRadius: '4px',
                  border: '1px solid #FC6E51'
                }}
              >
                {column['firstofmulti'] === 1 && (
                  <Chip
                    label='同日予約'
                    sx={{
                      borderRadius: '4px',
                      border: '1px solid #DA4453',
                      fontSize: '10px',
                      height: '21px',
                      '& .MuiChip-label': {
                        px: '4px',
                        color: '#DA4453',
                      },
                    }}
                    variant='outlined'
                  />
                )}
                {
                  column['first_visit'] === 1 && 
                  <Chip
                    label='初診'
                    sx={{
                      borderRadius: '4px',
                      border: '1px solid #364BC1',
                      fontSize: '10px',
                      height: '21px',
                      '& .MuiChip-label': {
                        px: '4px',
                        color: '#364BC1',
                      },
                    }}
                    variant='outlined'
                  />
                }
                <ColumnText
                  colText={column['text']}
                  colIndex={column['index']}
                />
              </Box>
            </td>
          ) : (
            <td
              key={time['hm'] + column['index']}
              align='left'
              className={`calendar-td ${time['show'] ? '' : 'border-top-none'}`}
              onClick={() =>
                props.handleOpenDialogAddReserve(column['index'], time['hm'])
              }
            />
          )
        )}
    </tr>
  ));
};

export default memo(DataCalendarTimes);
